import { Component, Input } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { LottieComponent } from "ngx-lottie";
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { FuseAlertComponent } from '@fuse/components/alert';
import { MatButtonModule } from '@angular/material/button';
import { bookingSuccessInput, scheduledSession } from 'app/models/bookings.model';

@Component({
  selector: 'app-booking-success',
  standalone: true,
  imports: [CommonModule,LottieComponent,FormsModule,MatIcon,FuseAlertComponent,MatButtonModule],
  templateUrl: './booking-success.component.html',
  styleUrl: './booking-success.component.scss'
})
export class BookingSuccessComponent {

  lottieConfig: Object;
  anim: any;

  @Input() data:bookingSuccessInput = new bookingSuccessInput();

  constructor(){

    this.lottieConfig = {
			path: "../../../../assets/images/lottie/success_mark.json",
			renderer: "svg",
			autoplay: true,
			loop: false,
    
		};
  }

  handleAnimation(anim: any) {
		this.anim = anim;
	}

  loadBookingPage(){
    window.location.href=`/bookings/${this.data.id}`
  }

}
